module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_28.71e3b6bf.jpg";